import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const tooltipProps = buildProps({
  textLine: {
    type: Number,
  },
  width: {
    type: Number,
  },
  popperClass: {
    type: String,
  },
} as const);

export type TooltipProps = ExtractPropTypes<typeof tooltipProps>;
